import React from 'react'
import Modal from 'react-bootstrap/Modal'
import omit from 'lodash/omit'

import l10n from '../i18n/I18N'

import closeImage from '../../static/images/icons/close-white.svg'
import './H5Modal.scss'

function H5Modal(props) {
  const { children, showClose, closeIconDesign, backdropClassName } = props

  return (
    <Modal
      {...omit(props, 'showClose', 'closeIconDesign', 'onHide')}
      onHide={() => {
        // Modal errors if there's no onHide method and we click outside the popup, so
        // make sure we always have one (it just won't do anything if props.onHide is unset)
        if (props.onHide) {
          props.onHide()
        }
      }}
      autoFocus={false}
      backdropClassName={backdropClassName}
      arialabelledby="h5modal-title"
      centered
    >
      {children}
      {showClose && closeIconDesign === 'default' && (
        <Modal.Header closeButton closeLabel={l10n.t['account.close']}></Modal.Header>
      )}
      {showClose && closeIconDesign === 'overlay' && (
        <button
          className="btn close-overlay"
          onClick={() => {
            if (props.onHide) {
              props.onHide()
            }
          }}
        >
          <img src={closeImage} alt={l10n.t['account.close']} />
        </button>
      )}
    </Modal>
  )
}

H5Modal.defaultProps = {
  closeIconDesign: 'default'
}

export default H5Modal
